<template>
    <div>
        <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
            <form @submit.prevent="store">
                <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
                    <text-input v-model="form.name" :error="form.errors.name" class="pr-6 pb-8 w-full"
                        :label="__('Name')" placeholder="Enter name (max 50 characters)" :maxlength="50"
                        :disabled="!user_access.faq.create" />

                    <select-input-filter placeholder="Start typing to search categories" :items="categories"
                        v-model="form.category_id" :error="form.errors.category_id" class="pr-6 pb-8 w-full lg:w-1/2"
                        :label="__('Category')" :disabled="!user_access.faq.create" />

                    <checkbox-input v-model="form.status" :error="form.errors.status" class="pr-6 pb-8 w-full lg:w-1/2"
                        :label="__('Active')" :disabled="!user_access.faq.create" />

                    <textarea-input v-model="form.details" :error="form.errors.details" class="pr-6 pb-8 w-full"
                        :label="__('Details')" :disabled="!user_access.faq.create" />
                </div>

                <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center space-x-2">
                    <Link class="btn-gray" :href="route('faqs.index')" as="button" type="button">
                    Cancel
                    </Link>

                    <loading-button v-if="user_access.faq.create" :loading="form.processing" class="btn-indigo"
                        type="submit" :disabled="!user_access.faq.create">
                        {{ __('Create') }} {{ __('FAQ') }}
                    </loading-button>

                    <!-- Show message if user doesn't have permission -->
                    <div v-else class="text-red-600 text-sm bg-red-50 px-4 py-2 rounded border border-red-200">
                        You don't have permission to create FAQs
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { Link } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInputFilter from '@/Shared/SelectInputFilter'
import TextareaInput from '@/Shared/TextareaInput'
import CheckboxInput from '@/Shared/CheckboxInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
    metaInfo: { title: 'Create FAQ' },
    components: {
        LoadingButton,
        CheckboxInput,
        TextareaInput,
        SelectInputFilter,
        TextInput,
        Link,
    },
    layout: Layout,
    props: {
        categories: Array,
        auth: Object,
    },
    remember: 'form',
    data() {
        return {
            form: this.$inertia.form({
                name: null,
                details: null,
                status: true,
                category_id: null,
            }),
            user_access: this.$page.props.auth.user.access || {},
        }
    },
    methods: {
        store() {
            if (!this.user_access.faq.create) {
                this.showToast('error', 'You do not have permission to create FAQs')
                return
            }

            this.form.post(route('faqs.store'), {
                preserveScroll: true,
                onSuccess: () => {
                    this.showToast('success', 'FAQ created successfully!')
                    // Navigate to index instead of resetting form
                    this.$inertia.visit(route('faqs.index'))
                },
                onError: (errors) => {
                    this.showToast('error', 'Failed to create FAQ')
                }
            })
        },

        showToast(type, message) {
            // Replace with your actual toast implementation
            // Example: this.$toast[type](message)
            alert(`${type}: ${message}`)
        }
    },
}
</script>
